const DEFAULT_ONLINE = true;

export function isNavigatorOnline(): boolean {
  if (typeof navigator === "undefined") {
    return DEFAULT_ONLINE;
  }

  const online = navigator.onLine;

  if (typeof online !== "boolean") {
    return DEFAULT_ONLINE;
  }

  return online;
}

export function subscribeToNavigatorOnline(listener: () => void): () => void {
  if (typeof window === "undefined") {
    return () => {};
  }

  const handleChange = () => {
    listener();
  };

  window.addEventListener("online", handleChange);
  window.addEventListener("offline", handleChange);

  return () => {
    window.removeEventListener("online", handleChange);
    window.removeEventListener("offline", handleChange);
  };
}
